import { render, staticRenderFns } from "./AnnexesManagement.vue?vue&type=template&id=7a232578"
import script from "./AnnexesManagement.vue?vue&type=script&lang=js"
export * from "./AnnexesManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports